export default "__VITE_ASSET__DQy6Mz4x__"